export class PMTCFv2InlineSettings {constructor(c={}) { 
  Object.assign(this, {
    accordionsSpacing: { paddingLeft: 20, paddingRight: 40, paddingTop: 16, paddingBottom: 16 },
    accordionsFont: { fontSize: 13, fontWeight: '500', color: '#000000', fontFamily: 'arial, helvetica, sans-serif' },
    panelSpacing: { paddingLeft: 20, paddingRight: 20, paddingTop: 5, paddingBottom: 20 },
    panelFont: { fontSize: 13, fontWeight: '400', color: '#555555', fontFamily: 'arial, helvetica, sans-serif' },
    toggleColor: '#47d747',
    toggleOffColor: '#cccccc',
    toggleNeutralColor: '#FFA800',

    customPurposesText: 'Custom Purposes',
    customPurposesLetter: 'C',
    specialPurposesText: 'Special Purposes',
    specialPurposesInfo: 'We have a need to use your data for this processing purpose that is required for us to deliver services to you.',
    liText: 'Manage Settings',
    liInfo: 'We also work with some partners on the basis of legitimate interest and other legal bases without consent.',
    purposeVendorTitle: 'Vendors',

    featuresText: 'Features',
    featuresInfo: 'Features are a use of the data that you have already agreed to share with us',
    // IAB Categories
    iabConsent: 'Consent Purposes',
    iabLegInt: 'Legitimate Interest Purposes',
    iabFeatures: 'Features',
    iabSpecialFeatures: 'Special Features',
    iabSpecialPurposes: 'Special Purposes',

    alphabetizeVendors: false,
    vendorsText: 'View All Providers',
    vendorsInfo: 'You can find a list of all third-party providers.',
    searchText: 'Search Site Vendors',
    otherText: 'Other Site Vendors',
    otherLetter: 'O',

    cookieText: 'Cookie Information',
    tableCategoryText: 'Category',
    tableCookieText: 'Cookie',
    tableDomainText: 'Domain',
    tableDurationText: 'Duration',

    viewAllText: 'View All',
    viewLessText: 'View Less',

    toggleOnText: '',
    toggleOffText: '',

    minHeight: { type: 'auto', value: 1 },
    maxHeight: { type: 'px', value: 400 },
    languages: {},
    selectedLanguage: '',
    link: { fontWeight: '400', color: '#1890ff', textDecoration: 'underline' },
    hover: { fontWeight: '400', color: '#1890ff', textDecoration: 'underline' },
    // for Vendor Content
    appleDataBrokerText: "Apple Data Broker",
    appleDataBrokerLetter: "A",
  });
  Object.assign(this, c);
}}

export const PMTCFv2InlineTypes = {
  height: {
    minHeight: { title: 'Min Scroll Height', type: 'Size' },
    maxHeight: { title: 'Max Scroll Height', type: 'Size' },
  },
  accordions: {
    accordionsSpacing: { title: 'Padding', type: 'Padding' },
    accordionsFont: { title: 'Font', type: 'Font' },
  },
  panel: {
    panelSpacing: { title: 'Padding', type: 'Padding' },
    panelFont: { title: 'Font', type: 'Font' },
  },
  'purpose content': {
    customPurposesText: { title: 'Custom', type: 'InputLanguage' },
    customPurposesLetter: { title: 'Custom Icon', type: 'InputLanguage' },
    specialPurposesText: { title: 'Spec. Purposes', type: 'InputLanguage' },
    specialPurposesInfo: { title: 'Spec. Purposes Info', type: 'InputLanguage' },
    liText: { title: 'Leg. Interest', type: 'InputLanguage' },
    liInfo: { title: 'Leg. Interest Info', type: 'InputLanguage' },
  },
  'feature content': {
    featuresText: { title: 'Features', type: 'InputLanguage' },
    featuresInfo: { title: 'Features Info', type: 'InputLanguage' },
  },
  'vendor content': {
    alphabetizeVendors : { title: 'Sort Vendors Alphabetically?', type: 'Switch' },
    vendorsText: { title: 'Vendors', type: 'InputLanguage' },
    vendorsInfo: { title: 'Vendors Info', type: 'InputLanguage' },
    purposeVendorTitle: { title: 'Vendor Title', type: 'InputLanguage' },
    searchText: { title: 'Search', type: 'InputLanguage' },
    otherText: { title: 'Others', type: 'InputLanguage' },
    otherLetter: { title: 'Other Icon', type: 'InputLanguage' },
    appleDataBrokerText: { title: 'Apple Data Broker Description', type: 'InputLanguage' },
    appleDataBrokerLetter: { title: 'Apple Data Broker Icon', type: 'InputLanguage' },
  },
  'IAB Categories': {
    iabConsent: { title: 'Consent Purposes', type: 'InputLanguage' },
    iabLegInt: { title: 'Legitimate Interest Purposes', type: 'InputLanguage' },
    iabFeatures: { title: 'Features', type: 'InputLanguage' },
    iabSpecialFeatures: { title: 'Special Features', type: 'InputLanguage' },
    iabSpecialPurposes: { title: 'Special Purposes', type: 'InputLanguage' },
  },
  'cookie content': {
    cookieText: { title: 'Cookie Info', type: 'InputLanguage' },
    tableCategoryText: { title: 'Category', type: 'InputLanguage' },
    tableCookieText: { title: 'Cookie', type: 'InputLanguage' },
    tableDomainText: { title: 'Domain', type: 'InputLanguage' },
    tableDurationText: { title: 'Duration', type: 'InputLanguage' },
  },
  'general content': {
    viewAllText: { title: 'View All', type: 'InputLanguage' },
    viewLessText: { title: 'View Less', type: 'InputLanguage' },
  },
  'toggle settings': {
    toggleColor: { title: 'ON Color', type: 'ColorPicker' },
    toggleOffColor: { title: 'OFF Color', type: 'ColorPicker' },
    toggleNeutralColor: { title: 'Neutral Color', type: 'ColorPicker' },
    toggleOnText: { title: 'Toggle ON Text', type: 'InputLanguage' },
    toggleOffText: { title: 'Toggle OFF Text', type: 'InputLanguage' },
  },
  links: {
    link: { title: 'Link Style', type: 'Links' },
    hover: { title: 'Hover Style', type: 'Links' },
  }
};